import { defineStore } from "pinia";

import { messageList, messageReadAll, messageDetail, messageRead, unreadMessageCount} from '@/api'

const useMessageStore = defineStore('message',{
  state:()=>({
    myMessageList:[],
    current:1,
    size:10,
    messagePageBean:{},
    messageDetail:{},
    unreadMessage:'',
  }),
  actions:{
    // 获取消息列表
    async messageListM(){
      const res = await messageList({
        current:this.current,
        size:this.size
      })
      if(res.code == 0){
        console.log('myMessageList')
        this.myMessageList = res.data.objList
        this.messagePageBean = res.data.pageBean
      }
    },
    // 获取消息详情
    async messageDetailM(id){
      const res = await messageDetail({id})
      if(res.code == 0){
        this.messageDetail = res.data
      }
    },
    // 已读一条
    async messageReadM(id){
      const res = await messageRead({id})
      if(res.code == 0){
        this.unreadMessageCountM()
        this.messageListM()

      }
    },
    // 已读全部
    async messageReadAllM(id){
      const res = await messageReadAll()
      if(res.code == 0){
        this.messageListM()
        this.unreadMessageCountM()
      }
    },
    // 未读消息总数
    async unreadMessageCountM(){
      const res = await unreadMessageCount()
      if(res.code == 0){
        this.unreadMessage = res.data
        console.log('res.data',res.data)
      }
    }
  }
})

export default useMessageStore